export default __webpack_public_path__ + "static/media/arrowleft.1f7b0a5d.svg";